import styles from './ReviewPopupSkeleton.module.css';
import cn from 'classnames';

export const ReviewPopupSkeleton = () => (
    <div className={styles.skeletonContainer}>
        <div className={cn(styles.skeletonImage, 'shimmer-bg')}></div>
        <div className={styles.skeletonTextGroup}>
            <div className={cn(styles.skeletonTitle, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonSubtitle, 'shimmer-bg')}></div>
        </div>
        <div className={styles.skeletonMetaWrap}>
            <div className={cn(styles.skeletonMetaItem, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonMetaItem, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonMetaItem, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonMetaItem, 'shimmer-bg')}></div>
        </div>
        <div className={styles.skeletonFullContent}>
            <div className={cn(styles.skeletonLabel, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonContentText, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonContentText, 'shimmer-bg')}></div>
        </div>
        <div className={styles.skeletonAdminNotes}>
            <div className={cn(styles.skeletonLabel, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonTextArea, 'shimmer-bg')}></div>
        </div>
        <div className={styles.skeletonQualityCheck}>
            <div className={cn(styles.skeletonLabel, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonCheckbox, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonCheckbox, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonCheckbox, 'shimmer-bg')}></div>
            <div className={cn(styles.skeletonCheckbox, 'shimmer-bg')}></div>
        </div>
    </div>
);